import { Button, Card, CardHeader, List, ListItem, makeStyles, Checkbox, tokens, Toolbar, Body1Strong } from "@fluentui/react-components";
import { bundleIcon, EditFilled, EditRegular, SaveFilled, SaveRegular } from "@fluentui/react-icons";
import { useMemo } from "react";

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem"
    },
    toolbar: {
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: tokens.borderRadiusMedium,
        padding: "0.25rem"
    },
    infoGrid: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "0.5rem",
        border: "1px solid " + tokens.colorNeutralStroke1,
        padding: "1rem",
        borderRadius: tokens.borderRadiusMedium
    },
    infoGrid__col: {
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem"
    },
    infoGrid__col__item: {
        display: "flex",
        gap: "0.5rem"
    }
});

const SaveIcon = bundleIcon( SaveFilled, SaveRegular );
const EditIcon = bundleIcon( EditFilled, EditRegular );

export default function FlightOps_Branch_Rings() {
    const styles = useStyles();

    const rings = useMemo(
        () => {
            return [
                { n: "Canary" },
                { n: "Beta" },
                { n: "Release" }
            ];
        },
        []
    );
    
    return (
        <div className={styles.root}>
            <Toolbar className={styles.toolbar}>
                <Button appearance="subtle" icon={<SaveIcon />}>
                    Save
                </Button>
            </Toolbar>

            <p>
                Select the rings this branch should include. Access to the rings included is governed by their access control settings.
            </p>

            <Card appearance="filled-alternative" style={{ maxWidth: "300px" }}>
                <CardHeader header={"Included Rings"} />
                
                <List>
                    {
                        rings.map(
                            ( v ) => {
                                return (
                                    <ListItem>
                                        <Checkbox label={
                                            <div style={{ display: "inline-flex", gap: "0.5rem", alignItems: "center" }}>
                                                <Body1Strong>{v.n}</Body1Strong>
                                                <Button size="small" icon={<EditIcon />} appearance="transparent" onClick={() => window.location.href = "/flightops/rings/" + v.n } />
                                            </div>
                                        } />
                                    </ListItem>
                                );
                            }
                        )
                    }
                </List>
            </Card>
        </div>
    );
}